import { hideLoading, showLoading } from 'react-redux-loading-bar';
import api from '../../utils/api/api';

import {
  SET_CLEAR_THREAD_DETAIL,
  SET_RECEIVE_THREAD_DETAIL,
  SET_DOWN_VOTE_THREAD_DETAIL,
  SET_NEUTRAL_VOTE_THREAD_DETAIL,
  SET_UP_VOTE_THREAD_DETAIL,
} from '../../utils/common/constant';

const ActionType = {
  SET_CLEAR_THREAD_DETAIL,
  SET_RECEIVE_THREAD_DETAIL,
  SET_DOWN_VOTE_THREAD_DETAIL,
  SET_NEUTRAL_VOTE_THREAD_DETAIL,
  SET_UP_VOTE_THREAD_DETAIL,
};

const receiveThreadDetailActionCreator = (detailThread) => {
  return {
    type: ActionType.SET_RECEIVE_THREAD_DETAIL,
    payload: {
      detailThread,
    },
  };
};

const clearThreadDetailActionCreator = () => {
  return {
    type: ActionType.SET_CLEAR_THREAD_DETAIL,
  };
};

const downVoteThreadDetailActionCreator = (userId) => {
  return {
    type: ActionType.SET_DOWN_VOTE_THREAD_DETAIL,
    payload: {
      userId,
    },
  };
};

const neutralVoteThreadDetailActionCreator = (userId) => {
  return {
    type: ActionType.SET_NEUTRAL_VOTE_THREAD_DETAIL,
    payload: {
      userId,
    },
  };
};

const upVoteThreadDetailActionCreator = (userId) => {
  return {
    type: ActionType.SET_UP_VOTE_THREAD_DETAIL,
    payload: {
      userId,
    },
  };
};

const asyncReceiveThreadDetail = (threadId) => {
  return async (dispatch) => {
    dispatch(showLoading());
    dispatch(clearThreadDetailActionCreator());

    try {
      const detailThread = await api.getThreadDetail(threadId);
      dispatch(receiveThreadDetailActionCreator(detailThread));
    } catch (error) {
      dispatch(hideLoading());
      alert(error.message);
    }

    dispatch(hideLoading());
  };
};

const asyncDownVoteThreadDetail = () => {
  return async (dispatch, getState) => {
    const { authUser, threadDetail } = getState();

    dispatch(showLoading());
    dispatch(downVoteThreadDetailActionCreator(authUser.id));

    try {
      await api.downVoteThread(threadDetail.id);
    } catch (error) {
      dispatch(hideLoading());
      alert(error.message);
    }

    dispatch(hideLoading());
  };
};

const asyncNeutralVoteThreadDetail = () => {
  return async (dispatch, getState) => {
    const { authUser, threadDetail } = getState();

    dispatch(showLoading());
    dispatch(neutralVoteThreadDetailActionCreator(authUser.id));

    try {
      await api.neutralVoteThread(threadDetail.id);
    } catch (error) {
      dispatch(hideLoading());
      alert(error.message);
    }

    dispatch(hideLoading());
  };
};

const asyncUpVoteThreadDetail = () => {
  return async (dispatch, getState) => {
    const { authUser, threadDetail } = getState();

    dispatch(showLoading());
    dispatch(upVoteThreadDetailActionCreator(authUser.id));

    try {
      await api.upVoteThread(threadDetail.id);
    } catch (error) {
      dispatch(hideLoading());
      alert(error.message);
    }

    dispatch(hideLoading());
  };
};

export {
  ActionType,
  receiveThreadDetailActionCreator,
  clearThreadDetailActionCreator,
  downVoteThreadDetailActionCreator,
  neutralVoteThreadDetailActionCreator,
  upVoteThreadDetailActionCreator,
  asyncReceiveThreadDetail,
  asyncDownVoteThreadDetail,
  asyncNeutralVoteThreadDetail,
  asyncUpVoteThreadDetail,
};
